var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSchedule = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16.615,
    viewBox: "0 0 18 16.615",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#33ab2e",
    d: "M7.538 3a5.529 5.529 0 0 0-2.769 10.32v6.3H20V5.769h-3.462v-.692h-1.384v.692H12.32A5.529 5.529 0 0 0 7.538 3zm0 1.385a4.154 4.154 0 1 1-4.153 4.153 4.145 4.145 0 0 1 4.153-4.153zm-.692 1.384v3.159l-1.19 1.19 1 1 1.38-1.39.195-.216V5.769zm6.036 1.385h2.272v.692h1.385v-.692h2.077v1.384h-5.539a5.451 5.451 0 0 0-.195-1.384zm0 2.769h5.733v8.308H6.154v-4.349a5.451 5.451 0 0 0 1.385.195 5.544 5.544 0 0 0 5.343-4.154zm.195 2.769v1.385h1.385v-1.385zm2.769 0v1.385h1.385v-1.385zm-8.308 2.77v1.385h1.385v-1.385zm2.769 0v1.385h1.385v-1.385zm2.769 0v1.385h1.385v-1.385zm2.769 0v1.385h1.385v-1.385z",
    transform: "translate(-2 -3)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSchedule, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/schedule.ba8f8c4a.svg";
export { ForwardRef as ReactComponent };